import {Component, ElementRef, EventEmitter, OnInit, Output, Renderer2} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {MenuItem} from 'primeng/api';
import {Breadcrumb} from 'primeng/breadcrumb';
import {BreadcrumbService} from './breadcrumb.service';
import {filter} from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { CommunicationService } from '../communication-service/communication.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [Breadcrumb, RouterModule, CommonModule,ButtonModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent implements OnInit {
  items: MenuItem[] = [];
  home: MenuItem = {icon: 'pi pi-home', label: 'Home', routerLink: '/'};

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private el:ElementRef,
    private renderer:Renderer2,
    private _communicationService: CommunicationService
  ) {
  }

  menuIconItem: MenuItem = {
    icon: 'pi pi-bars',
    styleClass: 'menu-icon-button',
    command: () => {
      console.log('Menu button clicked');
      this._communicationService.toggleSidebar()
      // You can toggle sidebar here
    }
  };

  ngOnInit(): void {
    this.items = this.breadcrumbService.buildBreadcrumbs(this.activatedRoute);

    // Subsequent navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.items = this.breadcrumbService.buildBreadcrumbs(this.activatedRoute);
      });
  }

  ngAfterViewInit() {
    // Target the <nav> inside <p-breadcrumb> and remove its .p-breadcrumb class
    const breadcrumbNav = this.el.nativeElement.querySelector('p-breadcrumb nav');
    if (breadcrumbNav) {
      this.renderer.removeClass(breadcrumbNav, 'p-breadcrumb');
    }
  }
}
